'use strict';

const generateBoxSize = (size)=>{
    switch(size){
        case 'sm':
            return 'size-6';
        case 'md':
            return 'size-8';
        case 'lg':
            return 'size-[60px]';
        default:
            return 'size-8';
    }
};
const SIZES = {
    sm: {
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        circle: [
            '4',
            '12',
            '20'
        ],
        r: '2'
    },
    md: {
        width: '32',
        height: '32',
        viewBox: '0 0 32 32',
        circle: [
            '4',
            '16',
            '28'
        ],
        r: '3'
    },
    lg: {
        width: '60',
        height: '60',
        viewBox: '0 0 60 60',
        circle: [
            '12',
            '30',
            '48'
        ],
        r: '5'
    }
};

exports.SIZES = SIZES;
exports.generateBoxSize = generateBoxSize;
